import { apiGet } from '../../utils/api';
import { getAuthToken, verifyAuth } from '../auth';

export function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const months = [
        'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
        'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
    ];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
}

export function redirectToErrorPage(type) {
    document.title = 'Не знайдено - BML';
    window.location.href = `error-page.html?type=${type}&reason=not_found`;
}

export async function fetchWithAccessCheck(endpoint, errorType) {
    try {
        const data = await apiGet(endpoint, { auth: false });
        if (!data) {
            redirectToErrorPage(errorType);
            return null;
        }

        if (data.status !== 'published') {
            const token = getAuthToken();
            if (!token) {
                redirectToErrorPage(errorType);
                return null;
            }
            try {
                await verifyAuth(token);
            } catch {
                redirectToErrorPage(errorType);
                return null;
            }
        }

        return data;
    } catch {
        redirectToErrorPage(errorType);
        return null;
    }
}
